module.exports = __webpack_public_path__ + "img/_lift.7674efa5.svg";